// The CountDownTimerTastic component serves as a wrapper for the CountdownTimerBanner, controlling
// its rendering based on device type and global activation settings. It detects whether the user is on
// a mobile, tablet, or desktop device using custom hooks (useMobileDevice, useTablet). Based on this detection,
// it checks the parent configuration (mobile, tablet, desktop) to determine if the banner should be displayed.
// If the current device type is disabled, the component returns null. Otherwise, it renders the CountdownTimerBanner
// with the appropriate device context.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import { CountdownTimerBannerType } from 'types/next';
import CountdownTimerBanner from 'components/commercetools-ui/organisms/countdown-timer';
import useMobileDevice from 'helpers/hooks/useMobileDevice';
import { useTablet } from 'helpers/hooks/useTabletDevice';
import useLocale from 'helpers/hooks/useLocale';

const CountDownTimerTastic = ({ data }: TasticProps<CountdownTimerBannerType>) => {
  const { isMobileDevice } = useMobileDevice();
  const isTablet = useTablet();
  const { getCurrency } = useLocale();
  const selectedLocale = getCurrency() === 'GBP' ? 'en-GB' : 'en-EU';
  const parentMobile = data?.mobile ?? true;
  const parentTablet = data?.tablet ?? true;
  const parentDesktop = data?.desktop ?? true;

  const deviceKey = isMobileDevice ? 'mobile' : isTablet ? 'tablet' : 'desktop';

  if (
    (deviceKey === 'mobile' && !parentMobile) ||
    (deviceKey === 'tablet' && !parentTablet) ||
    (deviceKey === 'desktop' && !parentDesktop) ||
    (selectedLocale === 'en-GB' && !data?.en_GB) ||
    (selectedLocale === 'en-EU' && !data?.en_EU)
  ) {
    return null;
  }
  return (
    <>
      <CountdownTimerBanner data={data} isMobileDevice={isMobileDevice} />
    </>
  );
};

export default CountDownTimerTastic;
